import { Box, LinearProgress, Typography } from "@mui/material";
import CardBox from "../../../../main/components/CardBox";
import { WbSunny, Thermostat } from "@mui/icons-material";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export type ActivePerformanceCardProps = {
    name: string;
    status: "online" | "offline" | "maintenance";
    sector: string;
    message?: string | null;
    potencia: string;
    performanceRatio: number | null;
    irradiancia: string;
    irradianciaRaw: number;
    irradianciaMaximaRaw: number;
    temperatura: string;
    hasCriticalEvent: boolean;
};

export default function ActivePerformanceCard({
    name,
    status,
    message,
    potencia,
    performanceRatio,
    irradiancia,
    temperatura,
    hasCriticalEvent
}: ActivePerformanceCardProps) {

    const displayName = name.replace(/_/g, " ").replace(/\s+/g, " ").trim();

    function getStatusLabel() {
        switch (status) {
            case "online":
                return "ON";
            case "offline":
                return "OFFLINE";
            case "maintenance":
                return "MAINTENANCE";
        }
    }

    function getStatusColor() {
        switch (status) {
            case "online":
                return "#4caf50";
            case "offline":
                return "#f44336";
            case "maintenance":
                return "#FFD54F";
            default:
                return "#8F969E";
        }
    }

    return (
        <CardBox
            sx={{
                borderRadius: "8px",
                border: "1px solid #8F969E",
                width: "100%",
                height: "auto",
                padding: "12px",
                display: "flex",
                flexDirection: "column",
                marginBottom: "6px",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px",
                    width: "100%",
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    {status === "online" ? (
                        <TaskAltIcon sx={{ fontSize: 16, color: getStatusColor() }} />
                    ) : (
                        <WarningAmberIcon sx={{ fontSize: 16, color: getStatusColor() }} />
                    )}
                    <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                        {displayName}
                    </Typography>
                    <Typography
                        sx={{ fontWeight: 500, fontSize: "12px", color: getStatusColor() }}
                    >
                        {getStatusLabel()}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: "16px",
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <WbSunny sx={{ fontSize: 14, color: "#FFD54F" }} />
                        <Typography sx={{ fontSize: "12px", color: "#8F969E" }}>
                            {irradiancia}
                        </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <Thermostat sx={{ fontSize: 14, color: "#50D974" }} />
                        <Typography sx={{ fontSize: "12px", color: "#8F969E" }}>
                            {temperatura}
                        </Typography>
                    </Box>
                </Box>

                {/* <Typography
                    sx={{ fontWeight: 500, fontSize: "12px", color: "#8F969E" }}
                >
                    {sector}
                </Typography> */}
            </Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    marginBottom: "8px",
                    width: "100%",
                }}
            >
                <Box>
                    <Typography sx={{ fontSize: "12px", color: "#8F969E" }}>
                        Potência Atual
                    </Typography>
                    <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
                        {potencia}
                    </Typography>
                </Box>

                <Box>
                    <Typography sx={{ fontSize: "12px", color: "#8F969E" }}>
                        Performance Ratio
                    </Typography>
                    <Typography sx={{ fontWeight: 700, fontSize: "16px", color: "#4caf50" }}>
                        {performanceRatio !== null && status !== "offline" ? `${(performanceRatio).toFixed(2).replace('.', ',')}` : "-"}
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", textAlign: "center", gap: 1, marginTop: "8px" }}>
                {hasCriticalEvent &&
                    <Box>
                        <WarningAmberIcon sx={{ fontSize: 16, color: "#f44336" }} />
                    </Box>}

                <Box sx={{ flexGrow: 1 }} >
                    <LinearProgress
                        variant="determinate"
                        value={performanceRatio && status !== "offline" ? (performanceRatio * 100 > 100 ? 100 : performanceRatio * 100) : 0}
                        sx={{
                            height: 5,
                            borderRadius: 6,
                            bgcolor: "#2E3445",
                            "& .MuiLinearProgress-bar": {
                                backgroundImage: "linear-gradient(to right, #FFD54F, green)",
                                borderRadius: 5,
                            },
                        }}
                    />
                </Box>

            </Box>
            {message && (
                <Box sx={{ marginTop: "8px" }}>
                    <Typography sx={{ fontSize: "12px", color: "#f44336" }}>
                        {message}
                    </Typography>
                </Box>
            )}
        </CardBox>
    );
}